<template>
  <b-container>
    <b-form @submit="onSubmit" @reset="onReset">
      <div class="form-row">
        <b-col class="mt-3" md="3">
          <b-form-group
            id="grp1"
            label-cols="2"
            label="Scheme"
            label-size="sm"
            label-for="ipLoanType"
          >
            <b-select
              id="ipLoanType"
              class="form-control"
              value-field="LoanType"
              size="sm"
              text-field="SchemeName"
              :options="schemes"
              v-model="form.LoanType"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col class="mt-3" md="3">
          <b-form-group
            id="grp2"
            label-cols="3"
            label="District"
            label-size="sm"
            label-for="ipDistrict"
          >
            <b-select
              id="ipDistrict"
              :options="districts"
              value-field="DistID"
              text-field="DistName"
              size="sm"
              :disabled="userDistrict != '00000000-0000-0000-0000-000000000000'"
              v-model="form.DistrictID"
              class="form-control"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col class="mt-3" md="3">
          <b-form-group id="grp3" label-cols="2" label="Bank" label-size="sm" label-for="ipAPSts">
            <b-select
              id="ipAPSts"
              class="form-control"
              :options="banks"
              value-field="BankID"
              text-field="BankName"
              required
              size="sm"
              v-model="form.BankID"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col class="mt-3" md="3">
          <b-form-group
            id="grp4"
            label-cols="4"
            label="Application No"
            label-size="sm"
            label-for="ipAppNum"
          >
            <b-form-input type="text" size="sm" id="ipAppNum" v-model="form.LoanApplicationNo" />
          </b-form-group>
        </b-col>
      </div>
      <b-row>
        <b-col class="mt-3" md="2">
          <b-form-group
            id="grp14"
            label-cols="3"
            label="LOI No"
            label-size="sm"
            label-for="ipLoiNum"
          >
            <b-form-input type="text" size="sm" id="ipLoiNum" v-model="form.LOINumber" />
          </b-form-group>
        </b-col>
        <b-col class="mt-3" md="3">
          <b-form-group
            id="grp13"
            label-cols="3"
            label="LOI Date"
            label-size="sm"
            label-for="ipLoiDt"
          >
            <date-picker
              v-model="LoiDate"
              format="DD-MMM-YYYY"
              id="ipLoiDt"
              lang="en"
              range
              size="small"
              style="width:250px"
            ></date-picker>
          </b-form-group>
        </b-col>
        <b-col class="mt-3" md="3">
          <b-form-group
            id="grp13"
            label-cols="4"
            label="Upload Date *"
            label-size="sm"
            label-for="ipAPDt"
          >
            <date-picker
              v-model="UpdateDate"
              format="DD-MMM-YYYY"
              id="ipAPDt"
              lang="en"
              range
              size="small"
              style="width:220px"
              required
            ></date-picker>
          </b-form-group>
        </b-col>
        <b-col class="mt-2" md="3">
          <b-button type="submit" size="sm" variant="primary" class="my-2" :disabled="isLoading">
            <span v-if="isLoading"><b-spinner small></b-spinner> Searching...</span>
            <span v-else>Search</span>
          </b-button>
          <b-button type="reset" size="sm" variant="secondary" class="my-2">Reset</b-button>
        </b-col>
      </b-row>
    </b-form>

    <hr />

    <b-row class="mb-2">
      <b-col md="4">
        <b-input-group>
          <b-form-input v-model="filter" placeholder="Type to Search" size="sm" />
          <b-input-group-append>
            <b-btn :disabled="!filter" @click="filter = ''" size="sm">Clear</b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col></b-col>
      <b-col md="4">
        <b-form-group horizontal label="Sort" class="mb-0" label-size="sm" label-cols="1">
          <b-input-group>
            <b-form-select v-model="sortBy" :options="sortOptions" size="sm">
              <option slot="first" :value="null">-- none --</option>
            </b-form-select>
            <b-input-group-append>
              <b-form-select :disabled="!sortBy" v-model="sortDesc" size="sm">
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <div v-if="isLoading" class="text-center py-4">
      <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
      <div class="mt-2">Loading sanction letters...</div>
    </div>
    <b-table
      v-else
      show-empty
      selectable
      select-mode="single"
      head-variant="dark"
      empty-text="No Disbursal available."
      stacked="md"
      bordered
      striped
      :items="claims"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      @filtered="onFiltered"
      @row-selected="onRowSelected"
      style="font-size:12px"
    >
      <template v-slot:cell(selected)="{ rowSelected }">
        <!-- <template slot="selected" slot-scope="row"> -->
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not Selected</span>
        </template>
      </template>
      <template v-slot:cell(action)="row">
        <a target="_blank" :href="getImgUrl(row.item)">View</a>
        <b-btn variant="link" size="sm" @click.stop="changeDoc(row.item)">Change</b-btn>
      </template>
    </b-table>
    <b-row>
      <b-col md="8" class="my-1">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
          size="sm"
        />
      </b-col>
      <b-col md="4" class="my-1">
        <b-form-group horizontal label="Per page" class="mb-0" label-size="sm" :label-cols="6">
          <b-form-select :options="pageOptions" v-model="perPage" size="sm" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-modal
        id="modalDoc"
        size="xl"
        title="Claim Details"
        scrollable
        hide-footer
      >
      <document-upload :UserID="selectedLoginID" :Stage="stage" :Id="selectedId" :OldPath="selectedOldPath"></document-upload>
    </b-modal>
  </b-container>
</template>

<script>
import apis from "@/apis";
import { mapState } from "vuex";
import lambda from "@/apis/lambda";
import * as _ from "lodash";
import axios from "axios";
import Spinner from "vue-simple-spinner";
import DatePicker from "vue2-datepicker";
import Formatter from "@/Formatter";
import DocumentUpload from "@/components/ClaimApproval/DocumentUpload";


export default {
  components: { Spinner, DatePicker, DocumentUpload },
  data() {
    return {
      show: false,
      showsts: false,
      LoiDate: null,
      UpdateDate: [null, null],
      districts: [],
      banks: [],
      schemes: [],
      approvalStatus: [],
      claims: [],
      fields: [
        { key: "selected", label: "Selected" },
        { key: "LoanApplicationNo", label: "Application No", sortable: true },
        { key: "LOINumber", label: "LOI Number", sortable: true },
        { key: "ApplicantName", label: "Applicant Name", sortable: true },
        {
          key: "LOIDate",
          label: "LOI Date",
          sortable: true,
          formatter: "convertDateFormat"
        },
        { key: "SanctionAmount", label: "Sanction Amount", sortable: true },
        { key: "LoanTenure", label: "Loan Tenure (months)", sortable: true },
        { key: "ROI", label: "Interest %", sortable: true },
        {
          key: "UpdatedDate",
          label: "Upload Date",
          sortable: true,
          formatter: "convertDateFormat"
        },
        { key: "LoanTenure", label: "Tenure Months" },
        { key: "BankName", label: "Bank Name" },
        { key: "BranchName", label: "Branch Name", sortable: true },
        {
          key: "DisbursementAmount",
          label: "Disbursement Amount",
          sortable: true
        },
        { key: "action", label: "Letter" }
      ],
      selected: [],
      form: {
        LoanType: 1,
        LoanApplicationNo: null,
        LOINumber: null,
        LOIStartDate: null,
        LOIEndDate: null,
        BankID: "00000000-0000-0000-0000-000000000000",
        DistrictID: "00000000-0000-0000-0000-000000000000",
        UserLoginID: null,
        RecordStartDate: null,
        RecordEndDate: null
      },
      selectedApplication: "",
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      stage:2,
      selectedLoginID:"00000000-0000-0000-0000-000000000000",
      selectedId:"00000000-0000-0000-0000-000000000000",
      selectedOldPath:""
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    userDistrict() {
      return this.$store.getters.getUserDistrict;
    }
  },
  methods: {
    changeDoc(item){
     this.selectedLoginID = item.LoginID;
     this.selectedId = item.LoanSanctionID;
     this.selectedOldPath = item.UploadSanctionLetter || "";
     this.$root.$emit("bv::show::modal", "modalDoc");
    },
    convertDateFormat(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
    getSchemes() {
      let promise = apis.getSchemes();

      promise
        .then(response => {
          if (response.status == 200) {
            //let rspns = response.body;
            //this.$store.dispatch("setSchemeList", rspns);
            this.schemes = response.body;
            this.form.LoanType = this.$store.getters.getLoanType;
          } else {
            this.alertText = "Unable to Load Scheme List, " + response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = "Unable to Load Scheme List, " + err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    getImgUrl(pic) {
      if (pic) {
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          pic.LoginID +
          "/" +
          pic.UploadSanctionLetter
        );
      }
    },
    onRowSelected(items) {
      this.selected = items;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getApprovalStatus() {
      let promise = apis.getApplicationStatusMstr();
      promise
        .then(response => {
          if (response.status == 200) {
            //let rspns = response.body;
            //this.$store.dispatch("setSchemeList", rspns);
            this.approvalStatus = response.body;
            this.form.ApplicationStatusID = this.$store.getters.getAppStatus;
          } else {
            this.alertText =
              "Unable to Load Approval Status List, " + response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText =
            "Unable to Load Approval Status List, " + err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },

    onSubmit(evt) {
      evt.preventDefault();
      this.getApplicationsSub();
    },

    getApplicationsSub() {
      this.isLoading = true;
      this.showDismissibleAlert = false;

      if (this.LoiDate != null && this.LoiDate[0]) {
        this.form.LOIStartDate = Formatter.convertDateFormatYMD(this.LoiDate[0]);
        this.form.LOIEndDate = Formatter.convertDateFormatYMD(this.LoiDate[1] || this.LoiDate[0]);
      } else {
        this.form.LOIStartDate = null;
        this.form.LOIEndDate = null;
      }

      if (this.UpdateDate != null && this.UpdateDate[0]) {
        this.form.RecordStartDate = Formatter.convertDateFormatYMD(this.UpdateDate[0]);
        this.form.RecordEndDate = Formatter.convertDateFormatYMD(this.UpdateDate[1] || this.UpdateDate[0]);
      } else {
        this.form.RecordStartDate = null;
        this.form.RecordEndDate = null;
      }

      let promise = apis.ReadSanctionLetterQuery(this.form);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.claims = response.body;
            this.totalRows = this.claims.length;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });

      //console.log(this.selectedDistrict);
    },

    onReset(evt) {
      evt.preventDefault();
      this.form = {
        LoanType: 1,
        LoanApplicationNo: null,
        LOINumber: null,
        LOIStartDate: null,
        LOIEndDate: null,
        BankID: "00000000-0000-0000-0000-000000000000",
        DistrictID: "00000000-0000-0000-0000-000000000000",
        UserLoginID: null
      };
    },
    getDistricts(stateid) {
      let promise = apis.getDistricts(stateid);

      promise
        .then(response => {
          if (response.status == 200) {
            this.districts = response.body;
            this.districts.unshift({
              DistID: "00000000-0000-0000-0000-000000000000",
              DistName: "All"
            });

            this.form.DistrictID = this.$store.getters.getUserDistrict;
            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    ReadBanks() {
      let promise = apis.ReadBankMaster();

      promise
        .then(response => {
          //console.log('Physical Response' ,response);
          if (response.status == 200) {
            this.banks = response.body;
            this.banks.unshift({
              BankID: "00000000-0000-0000-0000-000000000000",
              BankName: "All"
            });
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    }
  },
  created() {
    var dt = new Date();
    var dtInMs = dt.getTime();
    dtInMs -= 60 * 1000 * 60 * 24 * 365; //1 Year
    dt.setTime(dtInMs);

    this.UpdateDate[0] = dt;
    this.UpdateDate[1] = new Date();
  },
  mounted() {
    this.form.DistrictID = this.$store.getters.getUserDistrict;
    if (this.$route.query && this.$route.query.LoanApplicationNo) {
      this.form.LoanApplicationNo = this.$route.query.LoanApplicationNo;
      // Clear date filter when searching for a specific application
      this.UpdateDate = [null, null];
    }
    this.getDistricts("BB62F7B0-748D-4E64-AD4F-8EF691431FA1");
    this.getSchemes();
    this.ReadBanks();
    this.getApplicationsSub();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ClaimApproval/SanctionLetterList.vue